export const commandDevicesStatusTypes = {
  successful: 'success',
  failed: 'error',
  timeout: 'warning',
  pending: 'inactive',
  running: 'informational',
};

/* exitCode taken from https://support.jumpcloud.com/support/s/article/Command-Results-Error-Codes */
export const commandDevicesStatusMap = {
  [commandDevicesStatusTypes.successful]: {
    status: 'success',
    label: 'COMPLETED',
    exitCode: 0,
  },
  [commandDevicesStatusTypes.failed]: {
    status: 'error',
    label: 'FAILED',
    exitCode: -1,
  },
  [commandDevicesStatusTypes.timeout]: {
    status: 'warning',
    label: 'TIMED OUT',
    exitCode: 124,
  },
  [commandDevicesStatusTypes.pending]: {
    status: 'inactive',
    label: 'PENDING',
    exitCode: null,
  },
  [commandDevicesStatusTypes.running]: {
    status: 'informational',
    label: 'RUNNING',
    exitCode: null,
  },
};
